import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { useLazyQuery } from '@apollo/client';
import classNames from 'classnames';
import isClient from 'commons/isClient';
import { EMAIL_REGEX } from 'commons/constants';
import CtaButton from 'components/essentials/Cta/CtaButton';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
import { GET_CUSTOMER_IS_EXISTS } from '../queries';
const PreLogin = t0 => {
  const $ = _c(42);
  const {
    state: t1,
    actions,
    isLoginPage,
    showGuestLogin,
    onGuestLoginClick
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {
      email: ""
    } : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const state = t2;
  const [fromURL, setFromURL] = useState("");
  const inputRef = useRef(null);
  const [isEmailValid, setIsEmailValid] = useState(true);
  const location = useLocation();
  let t3;
  let t4;
  if ($[2] !== isLoginPage) {
    t3 = () => {
      if (isLoginPage && inputRef.current) {
        inputRef.current.focus();
      }
    };
    t4 = [isLoginPage];
    $[2] = isLoginPage;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      fetchPolicy: "no-cache"
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const [getCustomerIsExists, t6] = useLazyQuery(GET_CUSTOMER_IS_EXISTS, t5);
  const {
    loading: customerExistsLoading,
    data: customerIsExists
  } = t6;
  let t7;
  let t8;
  if ($[6] !== location.search) {
    t7 = () => {
      if (isClient() && location.search) {
        const params = new URLSearchParams(location.search);
        if (params.get("from")) {
          setFromURL(params.get("from"));
        }
      }
    };
    t8 = [location.search];
    $[6] = location.search;
    $[7] = t7;
    $[8] = t8;
  } else {
    t7 = $[7];
    t8 = $[8];
  }
  useEffect(t7, t8);
  let t10;
  let t9;
  if ($[9] !== actions || $[10] !== customerIsExists) {
    t9 = () => {
      if (customerIsExists && customerIsExists.getCustomerIsExists) {
        if (customerIsExists.getCustomerIsExists.errors) {
          setIsEmailValid(false);
          if (inputRef && inputRef.current) {
            inputRef.current.focus();
          }
        } else {
          setIsEmailValid(true);
          actions.onCustomerExistsUpdate(customerIsExists.getCustomerIsExists.exists);
        }
      }
    };
    t10 = [customerIsExists, actions];
    $[9] = actions;
    $[10] = customerIsExists;
    $[11] = t10;
    $[12] = t9;
  } else {
    t10 = $[11];
    t9 = $[12];
  }
  useEffect(t9, t10);
  let t11;
  if ($[13] !== getCustomerIsExists || $[14] !== state.email) {
    t11 = async evt => {
      evt.preventDefault();
      evt.stopPropagation();
      const isUpdatedEmailValid = EMAIL_REGEX.test(String(state.email.trim()).toLowerCase());
      if (!isUpdatedEmailValid) {
        setIsEmailValid(false);
        return false;
      }
      await getCustomerIsExists({
        variables: {
          email: state.email.trim()
        }
      });
      return false;
    };
    $[13] = getCustomerIsExists;
    $[14] = state.email;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  const onSubmit = t11;
  let t12;
  if ($[16] !== fromURL) {
    t12 = fromURL && fromURL.length > 0 && <div className="return-link"><a href={fromURL}>← Return</a></div>;
    $[16] = fromURL;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <h2 className="text-xl font-bold text-gray m-0">Log in or create account</h2>;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== state.email) {
    t14 = state.email.trim();
    $[19] = state.email;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== actions) {
    t15 = evt_0 => {
      setIsEmailValid(true);
      actions.onEmailChange(evt_0);
    };
    $[21] = actions;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = evt_1 => {
      const emailValid = EMAIL_REGEX.test(String(evt_1.target.value.trim()).toLowerCase());
      setIsEmailValid(emailValid);
    };
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  const t17 = !isEmailValid ? "Please enter a valid email address" : null;
  let t18;
  if ($[24] !== t14 || $[25] !== t15 || $[26] !== t17) {
    t18 = <LabeledTextInput name="email" value={t14} label="Email address" autoComplete="username" onChange={t15} onBlur={t16} errorMessage={t17} ref={inputRef} />;
    $[24] = t14;
    $[25] = t15;
    $[26] = t17;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  const t19 = customerExistsLoading || !isEmailValid;
  let t20;
  if ($[28] !== customerExistsLoading || $[29] !== t19) {
    t20 = <CtaButton type="submit" color="black" styling="solid-button" data-xc="signin-button" disabled={t19} block={true} isLoading={customerExistsLoading}>Continue</CtaButton>;
    $[28] = customerExistsLoading;
    $[29] = t19;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  let t21;
  if ($[31] !== onSubmit || $[32] !== t18 || $[33] !== t20) {
    t21 = <form method="POST" onSubmit={onSubmit}>{t18}{t20}</form>;
    $[31] = onSubmit;
    $[32] = t18;
    $[33] = t20;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== onGuestLoginClick || $[36] !== showGuestLogin) {
    t22 = !!showGuestLogin && <><div className={classNames("[background:none] h-3.5 relative text-center mt-[.825rem] mb-0", "[&_hr]:border-0 [&_hr]:![border-top:1px_solid_#f1f1f1] [&_hr]:mt-[-13px] [&_hr]:mx-auto [&_hr]:mb-2.5 [&_hr]:w-full")}><span className="text-xs inline-block relative -top-1.5 text-gray bg-gray-light9">or</span><hr aria-hidden="true" /></div><div className="text-center"><CtaButton size="sm" styling="link" color="brand" hasArrow={true} onClick={onGuestLoginClick}>Don't want an account? Continue as guest</CtaButton></div></>;
    $[35] = onGuestLoginClick;
    $[36] = showGuestLogin;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  let t23;
  if ($[38] !== t12 || $[39] !== t21 || $[40] !== t22) {
    t23 = <div className="text-gray"><div>{t12}{t13}{t21}{t22}</div></div>;
    $[38] = t12;
    $[39] = t21;
    $[40] = t22;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  return t23;
};
PreLogin.propTypes = {
  state: PropTypes.shape({
    email: PropTypes.string
  }),
  actions: PropTypes.shape({
    onFBCallback: PropTypes.func,
    onEmailChange: PropTypes.func,
    onCustomerExistsUpdate: PropTypes.func
  }),
  isLoginPage: PropTypes.bool,
  showGuestLogin: PropTypes.bool,
  onGuestLoginClick: PropTypes.func
};
export default PreLogin;